import { FC, useState } from "react";
import SwitchWithLabel from "@/components/ui/switch-with-label";
import ThumbSlider from "@/components/ui/thumb-slider";

interface AutoOptionProps {
    label: string;
    onChange: (checked: boolean) => void;
    checked: boolean;
    value: number;
    onValueChange: (value: number) => void;
}

const AutoOption: FC<AutoOptionProps> = ({ label, onChange, checked, value, onValueChange }) => {
    return (
        <div className="flex flex-col gap-2">
            <SwitchWithLabel label={label} onChange={onChange} checked={checked} />
            <ThumbSlider checked={checked} value={value} onValueChange={onValueChange} />
        </div>
    );
};

export default AutoOption;
